export default __webpack_public_path__ + "media/zurb/img/events/soapbox/soapbox-img2-b79e7fbd0b6669f9603b53380703ec39.png";